import {
  CircularProgress,
  FormControl,
  FormControlProps,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  Typography,
} from '@mui/material';
import React from 'react';

type OptionType = {
  disabled?: boolean;
  value: string | number;
  label: string | React.ReactNode;
};

type DropdownType = SelectProps & {
  loading?: boolean;
  loadingText?: string;
  options: OptionType[];
  label: string | React.ReactNode;
  formControlProps?: FormControlProps;
};

const Dropdown: React.FC<DropdownType> = ({
  className = '',
  fullWidth = false,
  required,
  options,
  label,
  value,
  loading = false,
  formControlProps,
  loadingText = 'Loading...',
  ...props
}) => {
  return (
    <FormControl
      fullWidth={fullWidth}
      className={className}
      variant={props.variant}
      required={required}
      size={props.size}
      {...formControlProps}
    >
      <InputLabel
        style={
          props.variant === 'outlined'
            ? { background: 'white', paddingLeft: 5, paddingRight: 10 }
            : {}
        }
      >
        {loading ? <LoadingIndicator text={loadingText} /> : label}
      </InputLabel>
      <Select
        label={label}
        value={value || ''}
        inputProps={{ MenuProps: { disableScrollLock: true } }}
        disabled={loading || props.disabled}
        {...props}
      >
        {options.map((item, indx) => (
          <MenuItem disabled={item.disabled} key={indx} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const LoadingIndicator: React.FC<{ text: string }> = ({ text }) => (
  <Typography variant="body1" display="flex">
    <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
    {text}
  </Typography>
);

export default Dropdown;
